import React from "react";
import UpdateProfileForm from "../components/form/UpdateProfileForm";
import UploadAvatarForm from "../components/form/UploadAvatarForm";
import UploadBannerForm from "../components/form/UploadBannerForm";
import { IonButton, IonContent, IonHeader, IonPage } from "@ionic/react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Edit.css";
import { UpdateProfileSettings } from "../components/form/UpdateProfileSettings/UpdateProfileSettings";
const Edit = () => {
  // const history = useHistory();
  const username = useSelector((state) => state.currentProfile?.data?.username);

  // const handleCancel = () => {
  //   if (username) history.push(`/profile/${username}`);
  //   else history.goBack();
  // };
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonContent>
          <div className="edit-page">
            <div className="profile-edit-header">
              <UploadBannerForm />
              <div className="avatar-positioner">
                <UploadAvatarForm />
              </div>
            </div>
            <UpdateProfileForm />
            {/* <hr className="edit-page-line" /> */}
            <UpdateProfileSettings />
            {/* <IonButton onClick={handleCancel} color="dark" fill="clear">
              Cancel
            </IonButton> */}
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default Edit;
